(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-product-media"] && !Shopify.designMode) return;
  try {
    
  // Inicijalizacija Swipera za sve instance sekcije (DOM ready)
  function initMobileProductMedia(section) {
    if (typeof Swiper === 'undefined') return;

    var mainEl = section.querySelector('.mobile-media-main');
    var thumbsEl = section.querySelector('.mobile-media-thumbs');
    if (!mainEl || !thumbsEl) return;

    var thumbs = new Swiper(thumbsEl, {
      slidesPerView: 4,
      spaceBetween: 16,
      watchSlidesProgress: true
    });

    var main = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      thumbs: {
        swiper: thumbs
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.mobile-product-media-section')
      .forEach(function (section) {
        initMobileProductMedia(section);
      });
  });

  // Shopify section load (kad se sekcija učita preko customizer-a)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.closest('.mobile-product-media-section');
    if (section) {
      initMobileProductMedia(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
